import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import ChatUserAvatar from './ChatUserAvatar/ChatUserAvatar';
import ChatArchiveDialog from './ChatArchiveDialog/ChatArchiveDialog';

import ChatContext from '../../context/index';
import { displayDate } from '../../helpers/index';
import formatLastMessage from '../../helpers/message';
import '../../context/global';

import './chatroomitem.scss';

const ChatRoomItem = ({ ...props }) => {
  const [title, setTitle] = useState('');
  const [status, setStatus] = useState('');
  const [userOnlineStatus, setUserOnlineStatus] = useState('offline');
  const [addArchiveDialog, setAddArchiveDialog] = useState(false);
  const {
    chatItemClick,
    addStar,
    addArchive,
    roomDetail,
    isStarred,
    isArchived,
    coverUrl,
    theIndex,
  } = props;

  const isOldChat = roomDetail.data !== '';

  const { currentUser, preDefinedRoom, activeRoom, trans } = useContext(ChatContext);

  const starBorder = isStarred ? 'star' : 'star_border';
  const archivedBorder = isArchived ? 'unarchive' : 'archive';
  const buyer = roomDetail.inviter.userId === currentUser.userId;

  let activeClass = '';
  let lastMessage = '';
  let lastMessageTime = '';

  const _handleClick = () => {
    chatItemClick(roomDetail);
  };

  const _addArchiveDialog = () => {
    setAddArchiveDialog(!addArchiveDialog);
  };

  const _rateFromList = e => {
    e.stopPropagation();
    chatItemClick(roomDetail, true);
  };

  const _addStar = e => {
    e.stopPropagation();
    addStar(roomDetail, currentUser);
  };

  const _addArchive = e => {
    e.stopPropagation();
    _addArchiveDialog();
    addArchive(roomDetail, currentUser);
  };

  const _findWhosOnline = () => {
    roomDetail.refresh((response, error) => {
      if (error === null) {
        Object.keys(response.members).forEach(k => {
          const member = response.members[k];
          if (member.userId !== currentUser.userId) {
            if (buyer) {
              setUserOnlineStatus(member.connectionStatus);
            } else if (roomDetail.inviter.userId === member.userId) {
              setUserOnlineStatus(member.connectionStatus);
            }
          }
        });
      }
    });
  };

  const _refreshOnlineStatus = () => {
    setInterval(() => {
      _findWhosOnline();
    }, 10000);
  };

  if (roomDetail.name === preDefinedRoom) {
    if (Object.keys(activeRoom).length === 0) {
      chatItemClick(roomDetail);
    }
  }

  useEffect(() => {
    _findWhosOnline();
    const roomInfo = isOldChat ? JSON.parse(roomDetail.data) : {};
    try {
      setTitle(isOldChat ? roomInfo.title.en : roomDetail.name);
    } catch (_) {
      setTitle(roomDetail.name);
    }
    setStatus(isOldChat ? roomInfo.status : 'current');
    _refreshOnlineStatus();
  }, [roomDetail.data]);

  if (roomDetail.url === activeRoom.url) {
    activeClass = 'active';
  }

  let chatInviter = '';
  Object.keys(roomDetail.members).forEach(k => {
    if (roomDetail.members[k].userId === roomDetail.inviter.userId) {
      chatInviter = roomDetail.members[k];
    }
  });

  if (roomDetail.lastMessage !== null) {
    lastMessage = roomDetail.lastMessage.message;

    lastMessage = formatLastMessage(roomDetail.lastMessage);

    lastMessageTime = displayDate(roomDetail.lastMessage.createdAt);
    if (lastMessageTime === 'Today' || lastMessageTime === 'Yesterday') {
      lastMessageTime = trans[lastMessageTime];
    }
  }

  const chatRoomCoverUrl = buyer ? coverUrl : roomDetail.inviter.profileUrl;
  const chatRoomInfoUser = buyer ? title : chatInviter.nickname;
  return (
    <div
      className={`chat-room-item ${activeClass}`}
      onClick={_handleClick}
      onKeyDown={_handleClick}
      role="button"
      tabIndex={theIndex}
    >
      <ChatUserAvatar coverUrl={chatRoomCoverUrl} onlineStatus={userOnlineStatus} trans={trans} />
      <div className="chat-room-info">
        <div className="chat-room-info-user">{chatRoomInfoUser}</div>
        <div className="chat-room-last-message">{lastMessage}</div>
        {!buyer ? <div className="chat-room-info-ad">{title}</div> : null}
        <div className={`chat-room-info-ad listing-status ${status}`}>
          {trans[global.listingStatus[status]]}
        </div>
        <div className="chat-room-action">
          <button type="button" onClick={_addStar}>
            <i className="material-icons">{starBorder}</i>
          </button>

          <button type="button" onClick={_addArchiveDialog}>
            <i className="material-icons-outlined">{archivedBorder}</i>
          </button>
          {isOldChat && (
            <button type="button" onClick={_rateFromList}>
              <i className="material-icons-outlined">thumb_up</i>
            </button>
          )}
        </div>
      </div>
      <div className="last-message-time">{lastMessageTime}</div>
      {roomDetail.unreadMessageCount !== 0 ? (
        <div className="unread-message">{roomDetail.unreadMessageCount}</div>
      ) : null}
      {addArchiveDialog ? (
        <ChatArchiveDialog
          close={_addArchiveDialog}
          confirm={_addArchive}
          archived={isArchived}
          trans={trans}
        />
      ) : null}
    </div>
  );
};

ChatRoomItem.propTypes = {
  chatItemClick: PropTypes.func.isRequired,
  addStar: PropTypes.func.isRequired,
  addArchive: PropTypes.func.isRequired,
  roomDetail: PropTypes.shape().isRequired,
  isStarred: PropTypes.bool.isRequired,
  isArchived: PropTypes.bool.isRequired,
  coverUrl: PropTypes.string.isRequired,
  theIndex: PropTypes.string.isRequired,
};

export default ChatRoomItem;
